<template>
<div v-if="visible">
    <div class="dim">
        <div class="pwlayer">
            <a type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" @click="close()" style="cursor: pointer;">
                    <img src="../assets/img/modal-close.png" alt="">
                </span>
            </a>
            <div class="modal-header txt-center">
                <h2 class="bold">E-mail 보내기</h2>
            </div>
            <div class="modal-body txt-center">
                <p class="mt-05">
                    Email Template을 받을 E-mail을 입력해 주세요.
                </p>
                <div class="mt-20 model-box pb-20">
                    <label for="">
                        <input type="text" placeholder="E-mail을 입력해 주세요." class="w-100per txt-left" v-model="member.email">
                    </label>
                </div>
            </div>
            <div class="modal-footer">
                <a class="btn-modal  pointer" @click="sendMail()">확인</a>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'emailModal',
    props: {
        visible: {
            type: Boolean,
            require: true,
            default: false
        },
        templete: {
            type: String,
            default: ""
        }
    },

    data: () => ({
        uidx: localStorage.getItem("uidx"),
        member: {}
    }),
    watch: {
        visible: function (newVal) {
            if (newVal == true) {
                this.visible = true;
                if(location.hostname == "stagest.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                }else if(location.hostname == "st.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.hostname == "student.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.hostname == "m.carrotenglish.net"){
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }else if(location.href.includes("how")){
                    if(location.href.includes("stage")){
                        this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
                    }else{
                        this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                    }
                }else{
                    this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
                }
                this.initPop();
                
                console.log(this.template);
                // console.log("a");
                // this.doSearch();
                // this.initPop();
            } else {
                this.visible = false;
                // this.info = [];
            }

        }
    },
    mounted() {

    },

    methods: {
        sendMail() {
            if(this.member.email == ""){
                alert("이메일를 입력해주세요.");
                return false;
            }
            var me = this;
            var params = {
                emailme: this.member.email,
                templete: this.templete,
                tmr: Date.now(),
                uidx: this.uidx,
                kname:localStorage.getItem("kname")
            };

            // console.log(params);
            


            this.axios.post(this.$store.state.host + '/rest/mobile/sendemailme_new', params).then(function (res) {
                if (res.data == 1) {
                    alert("전송되었습니다.");
                } else {
                    alert(res.data.err_msg);
                }
                // p_me = null;
                me.$emit('close');
            });
        },
        close() {
            this.$emit("close", false);
            // this.visible = false;
        },
        initPop() {
            var params = {
                uidx: this.uidx,
                accessKey: localStorage.getItem("accessKey")
            };
            var me = this;
            this.axios.get(this.$store.state.host + '/rest/mobile/getMember', {
                params: params
            }).then(function (res) {
                // console.log(res.data.member);
                me.member = res.data.member;
                if(me.member.email == ""){
                    me.member.email = me.member.uid;
                }
            });

        }
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.dim {
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 55;
    box-sizing: border-box;

    .pwlayer {
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 20px #0000001A;
        border-radius: 20px;
        width: 90%;
        margin: 0 auto;
        max-width: 500px;
        margin-top: 150px;
        position: relative;

        .modal-header {
            h2 {
                text-align: center;
                letter-spacing: 0px;
                color: #53CAFF;
                opacity: 1;
                font-size: 20px;
                font-weight: bold;
            }

            margin-bottom: 15px;
        }

        .modal-body {
            padding: 0 20px;

            p {
                text-align: center;
                letter-spacing: 0px;
                color: #000000;
                opacity: 1;
                font-size: 14px;
            }

            .model-box {
                label {
                    width: 100%;
                }
            }
        }
    }

}

input[type="text"],
input[type="password"] {
    border-radius: 0;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid #E9E9E9;
    font-size: 16px;
    height: 45px;
    padding: 0 10px;
}

.modal-footer {
    a {
        background: #53CAFF 0% 0% no-repeat padding-box;
        color: white;
    }
}

// .btn-modal {
//     font-weight: bold;
//     border-bottom-right-radius: 20px;
//     border-bottom-left-radius: 20px;
//     text-align: center;
//     padding: 15px 0;
//     width: 100%;
//     display: inline-block;
// }

// .btn-point {
//     background: $point-color;
//     color: #ffffff;
// }

// .btn-point-line {
//     background: #ffffff;
//     color: $point-color;
//     border: 1px solid $point-color;
// }
</style>
